(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["static-product"]) return;
  try {
    
   // Function to toggle the "Read More" functionality
  function toggleReadMore() {
    var content = document.querySelector('.read-more .content');
    var showMoreLink = document.querySelector('.read-more .show-more');
    var showLessLink = document.querySelector('.read-more .show-less');

    if (content.classList.contains('truncated')) {
      content.classList.remove('truncated');
      showMoreLink.style.display = 'none';
      showLessLink.style.display = 'inline';
    } else {
      content.classList.add('truncated');
      showMoreLink.style.display = 'inline';
      showLessLink.style.display = 'none';
    }
  }

  // Attach click event listeners to the "Read More" and "Read Less" links
  document.addEventListener('DOMContentLoaded', function() {
    var showMoreLink = document.querySelector('.read-more .show-more');
    var showLessLink = document.querySelector('.read-more .show-less');

    showMoreLink.addEventListener('click', function(event) {
      event.preventDefault();
      toggleReadMore();
    });

    showLessLink.addEventListener('click', function(event) {
      event.preventDefault();
      toggleReadMore();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
